import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import {
  getAiCoachPromoState,
  getGenAiOptOutWithGoogleCatalystOverride,
} from '@lyrahealth-inc/shared-app-logic/src/features/messaging/utils'
import { type Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { type MessageConversation } from '@lyrahealth-inc/shared-app-logic/src/models/messages/Messages'

import { getGenAiOptOut } from '../../data/customer/customerSelectors'
import { getAICoachConversations, getConversations, getEpisodes } from '../../data/lyraTherapy/lyraTherapySelectors'

/**
 * Hook that determines if AI Coach is available based on:
 * - AI Coach conversations exist
 * - Customer has not opted out of genAI, unless the Google Catalyst override applies
 * - AI Coach feature flag is enabled
 */
export const useShouldShowAICoach = (): { showAiCoach: boolean; aiCoachPromoEnabledProviderIds: string[] } => {
  const { isAiCoachEnabled, isGoogleCatalystLyraAiEnabled } = useFlags()
  const customerGenAiOptOut = useSelector(getGenAiOptOut)
  const conversations: MessageConversation[] = useSelector(getConversations)?.toJS() ?? []
  const aiCoachConversations: MessageConversation[] = useSelector(getAICoachConversations)?.toJS() ?? []
  const episodes: Episode[] = useSelector(getEpisodes)?.toJS() ?? []
  const genAiOptOut = getGenAiOptOutWithGoogleCatalystOverride({
    conversations,
    episodes,
    genAiOptOut: customerGenAiOptOut,
    isGoogleCatalystLyraAiEnabled,
  })
  return getAiCoachPromoState({
    conversations: aiCoachConversations,
    genAiOptOut,
    isAiCoachEnabled,
    episodes,
  })
}
